import 'selectize';

export default (function (w, d) {
    'use strict';

    function ProductHistoryController() {
        this.initSortSelectize();
        this.generateBill();
    }

    ProductHistoryController.prototype.initSortSelectize = function () {
        $('select').on('change', function (e) {
            e.preventDefault();
            let args = {
                _token: $('meta[name="csrf-token"]').attr('content')
            };


            $.get(window.location.href + '?sort=' + this.value, args, function (response) {
                $(".information").replaceWith('<div class="information">' + response.product_list_html + '</div>');
                // $(".page-identifier").replaceWith('<div class="page-identifier">'+response.page_identifier_html+'</div>');
                w.history.pushState({}, '', window.location.href);
            });
        });
    }

    ProductHistoryController.prototype.generateBill = function () {
        $('.generate-bill-pdf').on('click', function (e) {
            e.preventDefault();
            const id = $(this).data('order_id');
            const action = $(this).data('action');

            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                }
            });

            // process
            $.post(action, {id: id}, function (response) {
                if (response.type === 'error') {
                    message('error', response.message);
                } else {
                    window.location.href = $('.generate-bill-pdf').attr('href');
                }
            });
        });
    }

    return ProductHistoryController;
}(window, document));